import '../input/filter-input';

import { html, LitElement } from 'lit';
import { customElement, property, query } from 'lit/decorators.js';
import { FilterInput } from '../input/filter-input';
import { Option, OptionGroups } from '../input/filter-input';

@customElement('page-filter')
export class PageFilter extends LitElement {

    // Props

    @property({ type: String })
    name: string = '';

    @property({ type: String })
    property: string = '';

    @property({ type: Array })
    options: OptionGroups = {};

    @query('filter-input')
    _filterInput!: FilterInput;

    // Lifecycle Hooks

    connectedCallback() {
        super.connectedCallback();
        this.classList.add('PageFilter');
    }

    firstUpdated() {
        this._assessUrl();
    }

    // Render
    
    render() {
        return html`
            <filter-input
                name="${ this.name }"
                property="${ this.property }"
                .options="${ this.options }"
                @change="${ this._updateUrl }">
            </filter-input>
        `;
    }

    createRenderRoot() { 
        return this;
    }

    // Getters

    get _value() {
        return this._filterInput.selectedOption?.value;
    }

    // Methods

    private _assessUrl() {
		const options = Object.values(this.options).flat();
        const urlParms: URLSearchParams = new URLSearchParams(window.location.search);
        const paramValue: string | null = urlParms.get(this.property);
        if (paramValue) {
            const paramOption: Option | null = options.find((option) => {
                return option.value == paramValue;
            }) || null;
            this._filterInput.selectedOption = paramOption;
        }
    }

    private _updateUrl() {
        const urlParams: URLSearchParams = new URLSearchParams(window.location.search);
        if (this._filterInput.selectedOption) {
            urlParams.set(this.property, String(this._value));
            window.location.search = urlParams.toString();
        } else {
            urlParams.delete(this.property);
            window.location.search = urlParams.toString();
        }
    }

}